import axios from '@/integrations/axios'
import { toQueryParams } from '@/lib/utils'
import type {
  EstimateFeedbackListQuery,
  EstimateListQuery,
  EstimateListResponse,
  EstimateResponse,
  EstimateStatus,
  EstimateReportsResponse,
  EstimateReportResponse,
} from '@backend/schemas'

export const fetchCases = async ({ status, ...params }: Partial<EstimateListQuery> & { status: EstimateStatus[] }) => {
  const response = await axios.get<EstimateListResponse>(`/v1/estimates`, {
    params: toQueryParams({ ...params, status: status.join(',') }),
  })
  const data = response.data
  return data
}

export const fetchCaseById = async (id: string) => {
  const response = await axios.get<EstimateResponse>(`/v1/estimates/${id}`)
  const data = response.data
  return data
}

export const updateCaseStatus = async (id: string, status: EstimateStatus, message?: string) => {
  const response = await axios.patch<EstimateResponse>(`/v1/estimates/${id}`, {
    status,
    message,
  })
  const data = response.data
  return data
}

export const syncCase = async (id: string) => {
  const response = await axios.post<string>(`/v1/estimates/${id}/sync`)
  return response.data
}

export const fetchScenarios = async (params: Partial<EstimateFeedbackListQuery>) => {
  const response = await axios.get<EstimateReportsResponse>(`/v1/scenarios`, { params: toQueryParams(params) })
  return response.data
}

export const fetchEstimateFeedbackById = async (id: string) => {
  const response = await axios.get<EstimateReportResponse>(`/v1/scenarios/${id}`)
  const data = response.data
  return data.estimateFeedback
}

export type FindingResponseInput = {
  key: string
  answer?: boolean
  action?: 'N/A_for_car' | 'N/A_for_damage'
  clear?: boolean // removes the response ("Ångra svar")
}

export const respondToFinding = async (id: string, body: FindingResponseInput) => {
  const response = await axios.patch<EstimateReportResponse>(`/v1/scenarios/${id}`, body)
  const data = response.data
  return data.estimateFeedback
}
